module.exports = __webpack_public_path__ + "img/logo.784b46d2.png";